module.exports = __webpack_public_path__ + "static/media/cloud.4e3da7e3.svg";